import { useState, useEffect } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';

function PaymentHistory() {
  const [payments, setPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadPayments();
  }, []);

  const loadPayments = async () => {
    try {
      const response = await api.get('/billing/payments');
      setPayments(response.data);
    } catch (error) {
      toast.error('Failed to load payment history');
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const styles = {
      completed: 'bg-green-500/20 text-green-400',
      pending: 'bg-yellow-500/20 text-yellow-400',
      failed: 'bg-red-500/20 text-red-400',
      refunded: 'bg-gray-500/20 text-gray-400',
    };
    return styles[status] || styles.pending;
  };

  const getProviderIcon = (provider) => {
    if (provider === 'stripe') {
      return (
        <span className="inline-flex items-center gap-1">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305z"/>
          </svg>
          Stripe
        </span>
      );
    }
    if (provider === 'paypal') {
      return (
        <span className="inline-flex items-center gap-1">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 1.69a.77.77 0 0 1 .76-.644h6.725c2.234 0 3.962.564 5.133 1.677 1.172 1.113 1.693 2.657 1.55 4.592-.142 1.91-.813 3.432-1.993 4.526-1.18 1.093-2.767 1.64-4.72 1.64H9.49a.77.77 0 0 0-.76.644l-1.654 9.712z"/>
          </svg>
          PayPal
        </span>
      );
    }
    return provider;
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <span className="spinner w-8 h-8"></span>
      </div>
    );
  }

  if (payments.length === 0) {
    return (
      <div className="card text-center py-8">
        <p className="text-gray-400">No payment history yet.</p>
      </div>
    );
  }

  return (
    <div className="card">
      <h3 className="text-lg font-semibold mb-4">Payment History</h3>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="text-left text-gray-400 border-b border-gray-700">
              <th className="pb-3">Date</th>
              <th className="pb-3">Description</th>
              <th className="pb-3">Provider</th>
              <th className="pb-3">Amount</th>
              <th className="pb-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.id} className="border-b border-gray-800">
                <td className="py-3 text-sm">
                  {new Date(payment.created_at).toLocaleDateString()}
                </td>
                <td className="py-3">
                  {payment.extra_data?.plan_name || 'Subscription Payment'}
                </td>
                <td className="py-3 text-sm text-gray-400">
                  {getProviderIcon(payment.provider)}
                </td>
                <td className="py-3 font-medium">
                  ${(payment.amount / 100).toFixed(2)} {payment.currency?.toUpperCase()}
                </td>
                <td className="py-3">
                  <span className={`px-2 py-1 rounded text-xs ${getStatusBadge(payment.status)}`}>
                    {payment.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PaymentHistory;
